// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__13PuB","bigColWidth":"Table_bigColWidth__rzvnN","biggerColWidth":"Table_biggerColWidth__239HI","row":"Table_row__3QbMU","col":"Table_col__60_4U"};